/** Máscara CNPJ: XX.XXX.XXX/XXXX-XX */
export function maskCnpj(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 14)
  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
}

/** Máscara Telefone: (XX) XXXXX-XXXX ou (XX) XXXX-XXXX */
export function maskPhone(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 11)
  if (digits.length <= 10) {
    return digits
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
  }
  return digits
    .replace(/^(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
}

/** Valida CNPJ (algoritmo oficial) */
export function isValidCnpj(raw: string): boolean {
  const cnpj = raw.replace(/\D/g, '')
  if (cnpj.length !== 14) return false
  if (/^(\d)\1+$/.test(cnpj)) return false // todos iguais

  function calc(cnpj: string, weights: number[]) {
    let sum = 0
    for (let i = 0; i < weights.length; i++) sum += Number(cnpj[i]) * weights[i]
    const rem = sum % 11
    return rem < 2 ? 0 : 11 - rem
  }

  const w1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const w2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  const d1 = calc(cnpj, w1)
  const d2 = calc(cnpj, w2)

  return d1 === Number(cnpj[12]) && d2 === Number(cnpj[13])
}

/** Valida e-mail */
export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())
}

/** Senha: mínimo 6 chars */
export function isValidPassword(pw: string): boolean {
  return pw.length >= 6
}

/** Força da senha: 0–3 */
export function passwordStrength(pw: string): 0 | 1 | 2 | 3 {
  let score = 0
  if (pw.length >= 8) score++
  if (/[A-Z]/.test(pw) || /[a-z]/.test(pw)) score++
  if (/\d/.test(pw)) score++
  if (/[^A-Za-z0-9]/.test(pw)) score++
  return Math.min(3, score) as 0 | 1 | 2 | 3
}
